export default __webpack_public_path__ + "0e0c69147edbccd9abb3f5842aa62fb5.png";